  import axios from 'axios'
import {  Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import store from '@/store'
import GLOBAL from './global_variable'

const service = axios.create({
  baseURL: GLOBAL.baseBackURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    config.headers['X-Forwarded-Proto'] = 'https'
    // config.headers['Authorization'] = 'OAuth ' + getToken()
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)


// response interceptor
service.interceptors.response.use(
  response => {
    if( response.config.url===GLOBAL.baseBackURL+'article/download'){
      return response.data
    }
    const res = response.data
    if(res.code !== 20000){
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }

    return res
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js